module.exports = __webpack_public_path__ + "assets/img/product_effekt@2x.a5c56263.jpg";